<template>
  <v-container
    fluid
    grid-list-md
  >
    <v-data-table
      :items="allProcess"
      hide-actions
      item-key="id"
      class="elevation-1"
      :headers-length="7"
    >
      <template v-slot:headers>
        <tr>
          <th class="text-xs-center text-uppercase">
            Stages
          </th>
          <th class="text-xs-center text-uppercase">
            Steps
          </th>
          <th class="text-xs-center text-uppercase">
            Inlet
            products
          </th>
          <th class="text-xs-center text-uppercase">
            Outlet
            products
          </th>
          <th class="text-xs-center text-uppercase">
            Recipes
          </th>
          <th class="text-xs-center text-uppercase">
            Parameters
          </th>
          <th class="text-xs-center text-uppercase">
            Results
          </th>
        </tr>
      </template>
      <template v-slot:items="{ item }">
        <template v-if="hasRecipes(item)">
          <tr>
            <td
              colspan="7"
              class="text-uppercase text-xs-center font-weight-bold headline"
              style="background-color: #EEEEEE"
            >
              {{ item.name }}
              <v-btn
                v-if="!edit && item.unique_id"
                icon
                flat
                color="grey"
                :href="trialProcessWfPdfUrl(item.unique_id)"
                target="_blank"
              >
                <v-icon dark>print</v-icon>
              </v-btn>
            </td>
          </tr>
          <template v-for="stage in item.stages">
            <tr
              v-if="stage.steps.length"
              :key="`${item.id}${stage.id}`"
            >
              <td :rowspan="calcStageRowspan(stage)">
                {{ stage.name }}
              </td>
            </tr>
            <template v-for="step in stage.steps">
              <tr :key="`${item.id}${stage.id}${step.id}`">
                <td
                  :rowspan="calcStepRowspan(step)"
                  :colspan="calcStepColspan(step)"
                >
                  {{ step.name }}
                  <comments-badge
                    :edit="edit"
                    :commentState="commentState(step)"
                  />
                </td>
              </tr>
              <template v-if="step.outlet || step.inlet">
                <tr :key="`product_${item.id}${stage.id}${step.id}`">
                  <td
                    :rowspan="calcStepInletRowspan(step)"
                    :colspan="step.outlet && step.outlet.length ? 1 : 2"
                    v-if="step.inlet && step.inlet.length"
                  >
                    <ul
                      v-for="inlet in step.inlet"
                      :key="`inlet_${item.id}${stage.id}${step.id}${inlet.id}`"
                    >
                      <li>
                        {{ inlet.name }}
                      </li>
                    </ul>
                  </td>
                  <td
                    v-if="step.outlet && step.outlet.length"
                    :rowspan="calcStepOutletRowspan(step)"
                  >
                    <ul
                      v-for="outlet in step.outlet"
                      :key="`outlet_${item.id}${stage.id}${step.id}${outlet.id}`"
                    >
                      <li>
                        {{ outlet.name }}
                      </li>
                    </ul>
                  </td>
                </tr>
              </template>
              <template v-for="recipe in step.recipes">
                <tr :key="`${item.id}${stage.id}${step.id}${recipe.id}`">
                  <td
                    :rowspan="calcStepRecipesRowspan(recipe)"
                    :colspan="recipe.selectedParameters && recipe.selectedParameters.length ? 1 : 3"
                    class="no-wrap"
                  >
                    {{ recipe.name }}
                    <comments-badge
                      :edit="edit"
                      :commentState="commentRecipeState(recipe)"
                    />
                  </td>
                </tr>
                <tr
                  v-for="parameter in recipe.selectedParameters"
                  :key="`${item.id}${stage.id}${step.id}${recipe.id}${parameter.name}`"
                >
                  <td class="no-wrap">
                    {{ parameter.name.replace(/\_/g, ' ') }}
                  </td>
                  <td style="max-width: 40px">
                    <v-text-field
                      class="mb-3"
                      v-model="parameter.target"
                      hide-details
                      :label="parameter.measure"
                      :type="parameter.type"
                      @input="updateParams"
                    ></v-text-field>
                  </td>
                </tr>
              </template>
            </template>
          </template>
        </template>
      </template>
    </v-data-table>
    <template v-if="edit">
      <v-container class="pl-0 pr-0">
        <v-layout
          align-center
          justify-end
        >
          <v-btn
            @click="reset"
            :loading="isResetProcess"
            :disabled="isResetProcess || isSendingProcess"
            flat
            color="warning"
          >
            Reset
          </v-btn>
          <v-btn
            :loading="isSendingProcess"
            :disabled="isSendingProcess || isResetProcess"
            @click="saveProcesses"
            color="success"
          >
            Save
          </v-btn>
        </v-layout>
      </v-container>
    </template>
  </v-container>
</template>
<script>
import RecipeModule
  from '@/orm/models/RecipeModule';
import Process
  from '@/orm/models/Process';
import commentsBadge
  from '@/components/comments/commentsBadge';

export default {
  name      : 'processForPO',
  props     : {
    trial_id   : [Number, String],
    edit       : {
      type   : Boolean,
      default: () => false,
    },
    permissions: Object,
    process    : {
      type   : Array,
      default: () => [],
    },
    recipes    : {
      type   : Array,
      default: () => [],
    },
  },
  provide() {
    return {
      editProcess: this.editProcess,
      editStage  : this.editStage,
      editStep   : this.editStep,
    };
  },
  data() {
    return {
      isSendingProcess: false,
      isResetProcess  : false,
      allProcess      : [],
    };
  },
  watch     : {
    async currentGroup() {
      await this.reset();
    },
    process: {
      immediate: true,
      handler(process) {
        this.setDefValues(process);
      },
    },
  },
  computed  : {
    editLocal: {
      get() {
        return this.edit;
      },
      set(val) {
        this.$emit('update:edit', val);
      },
    },
    commentState() {
      const { id } = this.$route.params;
      return (step) => ({
        module  : 'PROCESS',
        id,
        type    : 'trials',
        uniqueId: step.unique_id,
      });
    },
    commentRecipeState() {
      const { id } = this.$route.params;
      return (recipe) => ({
        module  : 'RECIPE',
        id,
        type    : 'trials',
        uniqueId: recipe.unique_id,
      });
    },
  },
  methods   : {
    setDefValues(process) {
      if (!process.length) return;
      this.allProcess = JSON.parse(JSON.stringify(process)).map(process => {
        process.stages.forEach(stage => {
          stage.steps.forEach(step => {
            if (!step['recipes']) {
              step['recipes'] = [];
            }

            const recipes = this.recipes
              .filter(recipe => recipe.process_id === process.id)
              .map(recipe => ({
                id                : recipe.id,
                name              : recipe.name,
                unique_id         : recipe.unique_id,
                selectedParameters: step.selectedParameters,
              }));

            recipes.forEach(recipe => {
              if (!step['recipes'].find(r => r.id === recipe.id)) {
                step['recipes'].push(recipe);
              }
            });

          });
        });
        return process;
      });
    },
    reset() {
      this.isResetProcess = true;
      this.setDefValues(this.process);
      this.isResetProcess = false;
      this.editLocal = false;
    },
    async saveProcesses() {
      try {
        const processesLocal = this.allProcess;
        this.isSendingProcess = true;
        const { params } = this.$route;
        const { processes } = await RecipeModule.$create({
          params,
          data: {
            processes: processesLocal,
          },
        });
        await Process.create({
          data: processes,
        });
      } finally {
        this.isSendingProcess = false;
        this.editLocal = false;
      }
    },
    calcStageRowspan(stage, result = 0) {
      if (stage.steps) {
        result += stage.steps.length;
      }
      stage.steps.forEach(step => {
        if (step.inlet) {
          result += step.inlet.length ? 1 : 0;
        }
        if (step.outlet) {
          result += step.outlet.length ? 1 : 0;
        }
        if (step.recipes) {
          result += step.recipes.length;
          step.recipes.forEach(recipe => {
            if (recipe.selectedParameters) {
              result += recipe.selectedParameters.length;
            }
          });
        }
      });
      return result;
    },
    calcStepRowspan(step, result = 1) {
      if (step.inlet || step.outlet) {
        result += (step.inlet && step.inlet.length) || (step.outlet && step.outlet.length) ? 1 : 0;
      }
      if (step.recipes) {
        result += step.recipes.length;
        step.recipes.forEach(recipe => {
          if (recipe.selectedParameters) {
            result += recipe.selectedParameters.length;
          }
        });
      }
      return result;
    },
    calcStepInletRowspan(step, result = 1) {
      if (step.recipes) {
        result += step.recipes.length;
        step.recipes.forEach(recipe => {
          if (recipe.selectedParameters) {
            result += recipe.selectedParameters.length;
          }
        });
      }
      return result;
    },
    calcStepOutletRowspan(step, result = 1) {
      if (step.recipes) {
        result += step.recipes.length;
        step.recipes.forEach(recipe => {
          if (recipe.selectedParameters) {
            result += recipe.selectedParameters.length;
          }
        });
      }
      return result;
    },
    calcStepRecipesRowspan(recipe, result = 1) {
      if (recipe.selectedParameters) {
        result += recipe.selectedParameters.length;
      }
      return result;
    },
    hasRecipes(item) {
      return this.recipes.some(recipe => recipe.process_id === item.id);
    },
    calcStepColspan(step) {
      let result = 1;
      result += step.inlet && step.inlet.length ? 0 : 1;
      result += step.outlet && step.outlet.length ? 0 : 1;
      return result;
    },
    updateParams() {
      this.editLocal = true;
    },
    trialProcessWfPdfUrl(unique_id) {
      return '/api/v2/pdf/trial_process_wf/' + this.trial_id + '/' + unique_id;
    }
  },
  components: {
    commentsBadge,
  },
};
</script>
<style scoped>
  table tr {
    border: 0 !important;
    background: none !important;
  }

  table td,
  table th {
    border-right: 1px solid rgb(228, 228, 228);
    border-top: 1px solid rgb(228, 228, 228) !important;
  }

  table td:first-child,
  table th:first-child {
    border-left: 1px solid rgb(228, 228, 228);
  }

  table thead tr:first-child th {
    border-top: 1px solid rgb(228, 228, 228);
  }

  table tr + .v-datatable__expand-row {
    border: 1px solid rgb(228, 228, 228) !important;
    border-bottom: 0 !important;
  }

  .v-datatable__progress {
    border: 0 !important;
  }
</style>
